import LessonEditBlock, { LessonEditBlockProps } from './LessonEditBlock';
import withInteractor from './LessonEditBlock.interactor';
import withPresenter from './LessonEditBlock.presenter';

export type { LessonEditBlockProps };

export default withInteractor(withPresenter(LessonEditBlock));
